import { appState } from '@/store/appState'
import { Button } from '@/components/ui/Button'
import { dateTimeFormat } from '@/lib/format'
import { tr } from '@/i18n'
import type { SheetProps } from './index'

/* The `history` view (actions_bottom_sheet_widget.dart:334-476).
 *
 * No query here — the SAME 10 streamed docs the page already holds. No empty
 * state, no row taps. Apostrophe in the title is U+2019 (').
 * Row colours: activation #FF77B7 / deactivation #5B5A5A.
 * "Close": silent view switch (no update()) — page & map stay stale. */

interface Props extends SheetProps {
  forceRender: () => void
}

export function HistoryView({ userName, alerts, forceRender }: Props) {
  const list = alerts ?? []

  return (
    // Padding(40,34,40,16)
    <div style={{ width: '100%', padding: '34px 40px 16px' }}>
      <div
        data-history-panel
        style={{
          width: '100%',
          maxHeight: 300,
          background: 'var(--history-panel)',
          borderRadius: 50,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        {/* Padding(12,12,12,0) */}
        <p
          data-history-title
          style={{
            padding: '12px 12px 0',
            fontFamily: 'var(--font-poppins-regular)',
            fontWeight: 400,
            fontSize: 20,
            color: '#000000',
          }}
        >
          {tr.sheet.historyTitle(userName)}
        </p>

        {/* Flexible -> Padding(0,12,0,0) -> ListView.separated(gap 4) */}
        <div
          data-history-list
          style={{
            width: '100%',
            minHeight: 0,
            flex: '0 1 auto',
            overflowY: 'auto',
            paddingTop: 12,
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          {list.map((item) => {
            const active = item.data.status === true
            return (
              <p
                key={item.ref.id}
                data-history-row={active ? 'activated' : 'deactivated'}
                style={{
                  padding: '0 14px',
                  fontFamily: 'var(--font-poppins-regular)',
                  fontWeight: 400,
                  fontSize: 14,
                  color: active ? 'var(--primary)' : 'var(--deactivated-text)',
                }}
              >
                {(active ? tr.sheet.historyActivated : tr.sheet.historyDeactivated)(
                  dateTimeFormat('H:mm MM/dd/yy', item.data.createdAt),
                )}
              </p>
            )
          })}
        </div>

        {/* Padding(0,30,0,10) -> Close 120x44 white r90 */}
        <div style={{ padding: '30px 0 10px' }}>
          <Button
            text={tr.sheet.close}
            variant="outlinedLight"
            width={120}
            radius={90}
            style={{ ['--_bg' as string]: '#ffffff' }}
            onClick={() => {
              // silent, like "see history"
              appState.currentBottomSheetView = 'initial'
              forceRender()
            }}
          />
        </div>
      </div>
    </div>
  )
}
